import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api, { apiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        const token = localStorage.getItem("elvosh_token");
        if (!token) {
            setUser(null);
            setLoading(false);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data.user);
        } catch {
            localStorage.removeItem("elvosh_token");
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("elvosh_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const register = async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        localStorage.setItem("elvosh_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const googleSession = async (session_id) => {
        const { data } = await api.post("/auth/google/session", { session_id });
        localStorage.setItem("elvosh_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const logout = () => {
        localStorage.removeItem("elvosh_token");
        setUser(null);
    };

    const startGoogleLogin = () => {
        const redirect = `${window.location.origin}/auth/callback`;
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
    };

    return (
        <AuthContext.Provider
            value={{ user, loading, login, register, googleSession, logout, startGoogleLogin, refresh, setUser, apiError }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
